const noValueSymbol = Symbol();

export function tryGet<T>(fn: () => T, defaultValue?: never): T | null;
export function tryGet<T, U>(fn: () => T, defaultValue: U): T | U;
export function tryGet<T, U>(
  fn: () => T,
  defaultValue: U | typeof noValueSymbol,
) {
  try {
    return fn();
  } catch {
    return defaultValue === noValueSymbol ? null : defaultValue;
  }
}

export function assertDefined<T>(value: T | undefined) {
  if (value === undefined)
    throw new Error(`assertDefined failed for value: ${value}`);
  return value;
}

export function assertNonNullish<T>(value: T | null | undefined) {
  if (value === null || value === undefined)
    throw new Error(`assertNonNullish failed for value: ${value}`);
  return value;
}
